import MessageIcon from '@mui/icons-material/Message';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { ContextMenuButton } from 'shared/mui/ContextMenu';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';

export type ContextMenuCommentButtonProps = {
  onClick: VoidFunction;
};

export const ContextMenuCommentButton: React.FC<ContextMenuCommentButtonProps> = ({ onClick }) => {
  const { onCloseMenu } = useContextMenuContext();
  const translate = useTypedTranslate();

  const handleClick = () => {
    onClick();
    onCloseMenu();
  };

  return (
    <ContextMenuButton
      icon={<MessageIcon color="primary" />}
      label={translate('app.orderAdjustmentsReport.viewComment')}
      onClick={handleClick}
    />
  );
};
